var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from '@emotion/styled';
import { Enum_LiveStream_Status } from '@core/api';
import { useTranslation } from '@embed/hooks/react-i18nextLazy';
import { LiveStreamingBadge } from './LiveStreamingBadge';
const Wrapper = styled('div') `
  margin-top: 16px;
  margin-left: 16px;

  &:empty {
    display: none;
  }
`;
const DateWrapper = styled('div') `
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  text-shadow: 0 0 4px rgb(0 0 0 / 30%);
`;
const TimeWrapper = styled('div') `
  display: flex;
  flex-direction: row;
  align-items: baseline;
  text-shadow: 0 0 4px rgb(0 0 0 / 30%);
`;
const Time = styled('div') `
  font-size: 26px;
  line-height: 37px;
  font-weight: 600;
`;
const Meridiem = styled('div') `
  margin-left: 4px;
  font-size: 10px;
  font-weight: 400;
`;
export const LiveStreamingDateTime = (props) => {
    const { video } = props, rest = __rest(props, ["video"]);
    const { t } = useTranslation();
    if (!video) {
        return null;
    }
    const getLiveStreamingDateTime = (startAt) => {
        const time = new Date(startAt);
        const formatTime = time.toLocaleString([], {
            hour: 'numeric',
            minute: 'numeric',
        });
        const isMeridiem = ['AM', 'PM'].some((text) => formatTime.includes(text));
        const timeDisplay = getTimeDisplay(time);
        if (!isMeridiem) {
            return [timeDisplay, `${formatTime}`, ``];
        }
        return [
            timeDisplay,
            `${formatTime.slice(0, formatTime.length - 3)}`,
            `${formatTime.substring(formatTime.length - 2, formatTime.length)}`,
        ];
        function getTimeDisplay(streamTime) {
            const today = new Date();
            if (isSameDate(streamTime, today)) {
                return t('Today');
            }
            const tomorrow = new Date();
            tomorrow.setDate(today.getDate() + 1);
            if (isSameDate(streamTime, tomorrow)) {
                return t('Tomorrow');
            }
            return streamTime.toLocaleString([], {
                month: 'short',
                day: 'numeric',
            });
        }
        function isSameDate(date1, date2) {
            return (date1.getDate() === date2.getDate() &&
                date1.getMonth() === date2.getMonth() &&
                date1.getFullYear() === date2.getFullYear());
        }
    };
    const inFuture = (started_at) => new Date(started_at).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0);
    const isStreamingLive = video.video_type === 'live_stream' &&
        (video.live_stream_status === Enum_LiveStream_Status.ACTIVE ||
            video.live_stream_status === Enum_LiveStream_Status.PAUSED ||
            video.live_stream_status === Enum_LiveStream_Status.REPLAY);
    const isUpcomingLiveStreamingEvent = video.video_type === 'live_stream' &&
        video.live_stream_status === 'idle' &&
        inFuture(video.live_stream_scheduled_at) &&
        !isStreamingLive;
    const [liveStreamingDate, liveStreamingTime, liveStreamingMeridiem] = getLiveStreamingDateTime(video.live_stream_scheduled_at);
    return (<>
      {isUpcomingLiveStreamingEvent && (<Wrapper {...rest}>
          <DateWrapper>{liveStreamingDate}</DateWrapper>
          <TimeWrapper>
            <Time>{liveStreamingTime}</Time>
            <Meridiem>{liveStreamingMeridiem}</Meridiem>
          </TimeWrapper>
        </Wrapper>)}
      {isStreamingLive && (<Wrapper {...rest}>
          <LiveStreamingBadge video={video}/>
        </Wrapper>)}
    </>);
};
